// extracted by mini-css-extract-plugin
module.exports = {"sports-sprite":"UwbUT","sociable":"ffYIn","fb":"_XdiG","twitter":"qdGQA"};